import imgUrl from "../../assets/images/empty_folder.png";
import { getString } from "../../lang";
import "./../../index.css";

const NoData = () => {
    return (
        <div>
            <div className="flex justify-center items-center">
                <img src={ imgUrl } style={{ height: '100px', width: '100px' }} alt="No Data" />
            </div>
            <div className="text-center card-title-color">{getString("no_records_found")}</div>
        </div>
    )
}

export default NoData;